// @file Helper functions for billing components.
import { __ } from 'bits/intl'
import { UpgradeStep } from 'vuexstore/modules/plans'

export function membershipUpgradeTiersText(currentUser, plans): Record<string, any> {
  return {
    neon: {
      planKey: 'neon',
      name: __('Basic'),
      info: {
        padlets: __('%{num} padlets', { num: currentUser.quota.walls_limit }),
        uploads: __('%{fileSize} /upload', { fileSize: '25MB' }),
      },
      price: {
        monthly: __('Free'),
      },
    },
    platinum: {
      planKey: 'platinum',
      name: __('Pro'),
      info: {
        padlets: __('%{num} padlets', { num: 'Unlimited' }),
        uploads: __('%{fileSize} /upload', { fileSize: '250MB' }),
      },
      price: {
        monthly: __('%{amount} /month', { amount: plans.platinum.monthly.price }),
        annual: __('%{amount} /year', { amount: plans.platinum.annual.price }),
      },
    },
  }
}

export function getUpgradeStepFromQuota(currentUserQuota): UpgradeStep {
  if (currentUserQuota.walls_used === currentUserQuota.walls_limit) return UpgradeStep.AtPadletQuota
  else if (currentUserQuota.walls_used < currentUserQuota.walls_limit) return UpgradeStep.BelowPadletQuota
  return UpgradeStep.OverPadletQuota
}

export function normalizedPaymentSchedule(paymentSchedule: string): 'monthly' | 'annual' {
  return paymentSchedule === 'month' ? 'monthly' : 'annual'
}
